// src/components/HR/HRVerificaPersonale.jsx
// Wrapper HR per VerificaPersonale con tema verde
import React from 'react';
import VerificaPersonale from '../Admin/VerificaPersonale';
import '../Admin/VerificaPersonale.css';
import './hr.css'; // Sovrascrizione stili tema verde generale
import './HRVerificaPersonale.css'; // ✅ Sovrascrizione specifica VerificaPersonale

/**
 * Wrapper HR per il componente VerificaPersonale
 * 
 * Utilizza lo stesso componente Admin ma con:
 * - Tema verde HR (sovrascrive colori)
 * - Stesso comportamento e funzionalità
 * - Accesso solo per ruolo HR
 * 
 * Il componente VerificaPersonale è condiviso tra Admin e HR
 * Gli stili vengono sovrascritti dal CSS hr.css
 */
const HRVerificaPersonale = () => {
  return (
    <div className="hr-panel">
      {/* Wrapper con classe hr-panel per applicare tema verde */}
      <VerificaPersonale />
    </div>
  );
};

export default HRVerificaPersonale;